import React, { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import { FormikProps } from 'formik'

import { breakpoints, colors, fontSizes, fontWeights } from '@/styles'
import { Button } from '@/components/button-new'
import { ArrowLeft } from '@/components/icons'

import { Listing } from '../types/Listing'

const ActionsSection = styled.div<{ showPrev: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${props => (props.showPrev ? 'space-between' : 'flex-end')};
  width: 100%;
  @media screen and (max-width: ${breakpoints.phoneMax}) {
    background: ${colors.blue96};
    padding: 16px;
    padding-bottom: 100px;
    border-top: 1px solid ${colors.grey80};
  }
`

const CustomButton = styled(Button)`
  background-color: ${colors.blue32};
  width: fit-content;
  max-width: fit-content;
  min-width: 90px;
`

const CustomBackButton = styled(CustomButton)`
  background: transparent;
  color: ${colors.blue32} !important;
  font-size: ${fontSizes.regular};
  font-weight: ${fontWeights.regular} !important;
`

type Props = {
  formikProps: FormikProps<Listing>
  currentStep: number
  setCurrentStep: Dispatch<SetStateAction<number>>
  clickId: string
}

const ActionSection = ({
  formikProps,
  currentStep,
  setCurrentStep,
  clickId
}: Props) => {
  const { t } = useTranslation()
  const { values, setValues, isSubmitting } = formikProps
  const isInitialStep = currentStep === 0
  const isFinalStep = currentStep === 4

  const onPrev = () => {
    if (currentStep === 3) {
      setValues({
        type: values.type,
        scope: values.scope,
        suite: '',
        building: '',
        groupListing: '',
        address: '',
        hide_unit_number: false,
        building_id: null,
        building_name: '',
        street_number: '',
        street_name: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        full_name: '',
        email: '',
        password: ''
      })
    }

    if (currentStep === 4) {
      setValues({
        ...values,
        full_name: '',
        email: '',
        password: ''
      })
    }

    setCurrentStep((prev: number) => prev - 1)
  }

  return (
    <ActionsSection showPrev={!isInitialStep}>
      {!isInitialStep && (
        <CustomBackButton
          type="button"
          onClick={onPrev}
          theme={'text'}
          disabled={isSubmitting}
        >
          <ArrowLeft width={12} />
          Back
        </CustomBackButton>
      )}

      <CustomButton id={clickId} type="submit" disabled={isSubmitting}>
        {isFinalStep
          ? t('b.auth.create.continue.button', 'Continue')
          : t('b.button.title.next', 'Next')}
      </CustomButton>
    </ActionsSection>
  )
}

export default ActionSection
